module.exports = __webpack_public_path__ + "assets/images/arrow-right-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/arrow-right-on.png
// module id = 1482
// module chunks = 1